'use strict';
var seen = Symbol('circular-ref-tag');
var rawSymbol = Symbol('pino-raw-err-ref');
var pinoErrProto = Object.create({}, {
    type: {
        enumerable: true,
        writable: true,
        value: undefined
    },
    message: {
        enumerable: true,
        writable: true,
        value: undefined
    },
    stack: {
        enumerable: true,
        writable: true,
        value: undefined
    },
    aggregateErrors: {
        enumerable: true,
        writable: true,
        value: undefined
    },
    raw: {
        enumerable: false,
        get: function get() {
            return this[rawSymbol];
        },
        set: function set(val) {
            this[rawSymbol] = val;
        }
    }
});
Object.defineProperty(pinoErrProto, rawSymbol, {
    writable: true,
    value: {}
});
module.exports = {
    pinoErrProto: pinoErrProto,
    pinoErrorSymbols: {
        seen: seen,
        rawSymbol: rawSymbol
    }
};
